import React, { CSSProperties, ReactNode } from 'react'

import { Progress } from 'antd'
import { ProgressGradient, ProgressSize, ProgressType } from 'antd/lib/progress/progress'

declare const ProgressStatuses: ['normal', 'exception', 'active', 'success']

interface ProgressProps {
  strokeLinecap?: 'butt' | 'square' | 'round'
  strokeWidth?: number
  strokeColor?: string | ProgressGradient
  type?: ProgressType
  percent?: number
  size?: ProgressSize
  status?: (typeof ProgressStatuses)[number]
  className?: string
  successPercent?: number
  format?: (percent?: number, successPercent?: number) => ReactNode
  showInfo?: boolean
  trailColor?: string
  width?: number
  style?: CSSProperties
  gapDegree?: number
  gapPosition?: 'top' | 'bottom' | 'left' | 'right'
}

const Feedback = (props: ProgressProps) => {
  return <Progress {...props}></Progress>
}

export default Feedback
